/* IMPORTS */
import React, { useMemo } from "react";
import {
  DatasetTypes,
  MeasurementTypes,
  SelectedDatasetMeasurementsTypes,
  SelectedMeasurementsObjectTypes,
} from "./ObjectInterfaces";

/* Assigning the prop types */
interface MeasurementProps {
  dataset: DatasetTypes;
  measurement: MeasurementTypes;
  selectedMeasurements: SelectedMeasurementsObjectTypes;
  onMeasurementClick: any;
}

/* Measurement Component */
export const Measurement = ({
  dataset,
  measurement,
  selectedMeasurements,
  onMeasurementClick,
}: MeasurementProps) => {
  const measurementSelected = useMemo(() => {
    let measurementObject: SelectedDatasetMeasurementsTypes = selectedMeasurements[dataset.uuid];
    // TODO rewrite into measurementObject?.indexes.find
    if (measurementObject) {
      for (let i: number = 0; i < measurementObject.indexes.length; i++) {
        if (
          measurementObject.indexes[i] === measurement.index &&
          measurementObject.names[i] === measurement.name
        ) {
          return true;
        }
      }
    }
    return false;
  }, [dataset.uuid, measurement.name, measurement.index, selectedMeasurements]);

  /* JSX */
  return (
    <li
      key={measurement.id}
      className={"row d-flex p-1 border-dash" + (measurementSelected ? " active text-success" : "")}
      onClick={() => {
        onMeasurementClick(measurementSelected, measurement, { ...selectedMeasurements });
      }}
    >
      <div className="col-1">{measurementSelected ? <i className="icn_tick" /> : ""}</div>
      <div className="col-10">
        <span>{measurement.display_name}</span>
      </div>
    </li>
  );
};
